import { createApi } from "@reduxjs/toolkit/query/react";

import { axiosBaseQuery } from "./services/axiosBaseQuery";

/**
 * The single authenticated RTK Query API (PLX §6). Every feature injects its
 * endpoints here via `baseApi.injectEndpoints({ overrideExisting: false })`
 * from `src/features/<x>/api/`. No endpoints are declared inline — the base
 * only owns the axios base query + the domain tag registry.
 */
export const TAG_TYPES = [
  "BillingPreferences",
  // Consolidated billing domain (billing accounts, statements, ledger, invoices).
  "BillingAccounts",
  "Statements",
  // Extra files staged onto one bill's email, alongside the statement itself.
  "StatementAttachments",
  "Ledger",
  "Invoices",
  // Saved cards on a billing account — so the wallet refreshes when one is added or edited.
  "PaymentMethods",
  "Session",
  "User",
  "ProfilePicture",
  "HsaCard",
  // Commission / distribution domain (dev catch-up features).
  "Brokers",
  "Agencies",
  "AgencyLogin",
  "AgentAllocations",
  "AgentMappings",
  "CommissionRules",
  "PayoutRules",
  "PayoutSplits",
  "PayoutLedger",
  "PayoutPayments",
  // A payout recipient's pay-to bank account (masked), per recipient and per ledger slice.
  "RecipientBank",
  // Commission disputes: per dispute, its history and documents, per recipient and per scope.
  "CommissionDisputes",
] as const;

export const baseApi = createApi({
  reducerPath: "api",
  baseQuery: axiosBaseQuery(),
  tagTypes: TAG_TYPES,
  endpoints: () => ({}),
});
